// extracted by mini-css-extract-plugin
export default {"FeedbackBox":"SubmitFeedback_FeedbackBox__ZKXT4"};